module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_awards-f9c0724c79ba10a23b4323156e33b2ea.png";